import { add } from 'date-fns';
import dayjs from 'dayjs';
import * as yup from 'yup';
const today = dayjs();

export const AllocatePaymentValidation = yup.object().shape({
    paymentMethod: yup.string().required('Select a payment method'),
    balance: yup.number().required('Required'),
    paymentAmount: yup
        .number()
        .typeError('Required')
        .required('Required')
        .max(
            yup.ref('balance'),
            'Please enter an amount less than the outstanding amount of XX.XX on the invoice'
        )
        .min(0.01, 'Please enter an amount of 0.01 or greater'),
    date: yup
        .date()
        .required('Date is required')
        .max(add(today.toDate(), { days: 1 }), 'Date cannot be after today'),
});
